import { lazy, Suspense, useCallback } from "react";
import { Loading } from "../../elements/Loading";
import { useEntityPage } from "../useEntityPage";
import type { Sitemap } from "./sitemapEntries";

// Lazy so the drag and drop library isn't loaded behind every record page.
const SitemapDesigner = lazy(() => import("./SitemapDesigner"));

/** The page's body: the sitemap designer, editing the record's sitemap like any other value. */
export function SitemapField() {
  const { record, onFieldChange, fieldErrors } = useEntityPage();
  const sitemap = record?.sitemap as Sitemap | undefined;

  const onPendingChange = useCallback(
    // Undefined rather than false, so closing an untouched edit leaves nothing changed.
    (pending: boolean) => onFieldChange({ sitemapPendingEdit: pending || undefined }),
    [onFieldChange]
  );

  if (!sitemap) {
    return null;
  }

  return (
    <Suspense fallback={<Loading />}>
      <SitemapDesigner
        sitemap={sitemap}
        onChange={(next) => onFieldChange({ sitemap: next })}
        onPendingChange={onPendingChange}
        saveError={fieldErrors.sitemap}
      />
    </Suspense>
  );
}

export default SitemapField;
